export default {
  buttons: {
    remove: 'Remover',
  },
  title: 'Código promo ou Cartão oferta',
};
